module.exports = __webpack_public_path__ + "static/media/preview_screen8.43110153.png";